export default "__VITE_ASSET__CBRwPA$P__"